/* eslint-disable react/no-array-index-key */
import React from 'react';

import BLFrame from './ButtonListFrame';
import ButtonCell from './ButtonListCell';

export default (props) => {
  const buttons = React.Children.toArray(props.children);
  if (!buttons.length) {
    return '';
  }

  const cleanProps = { ...props };
  delete cleanProps.children;
  const expandFirst = cleanProps.expandFirst;
  const expandLast = cleanProps.expandLast;
  return (
    <BLFrame {...cleanProps} data-rest="button list">
      {buttons.map((b, i) => {
        const doExpand = (!i && expandFirst) || ((i >= (buttons.length - 1)) && expandLast);
        return (<ButtonCell
          expand={doExpand}
          rightAlign={ doExpand && i}
          key={i}
        >{b}
        </ButtonCell>);
      })}
    </BLFrame>
  );
};
